<template>
  <div id="app">
    <header class="site-header">
      <div class="container">
        <div class="flex align-center">

          <div class="logo">
            <h1>URLinks</h1>
            <router-link v-if="!isAuthenticated" to="/login"></router-link>
            <router-link v-if="isAuthenticated" to="/painel"></router-link>
          </div>

          <div class="search" v-if="isAuthenticated">
            <form action="https://www.google.com/search" method="get" target="_blank">
              <div class="field">

                <button type="submit"><svg fill="" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"></path></svg></button>
                <input type="text" name="q" required  placeholder="Pesquisar no Google">
              </div>
              <div class="powered"></div>
            </form>
          </div>


          <div id="profile" v-if="isAuthenticated" :class="{isAnonymous:userIsAnonymous}">

            <div v-if="userIsAnonymous" class="anonymousWarning">
              <a href="#" @click.prevent="identifyAnonymous">Registre-se aqui para que suas configurações sejam salvas.</a>
            </div>

            <div class="avatar" @click.stop="profileOpened=!profileOpened">

              <img v-if="userAvatar" :src="userAvatar">

              <svg v-if="!userAvatar" class="svgNoAvatar" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 24 24" xml:space="preserve">
                <circle cx="12" cy="8" r="5"/>
                <path d="M16.5,12c-1.1,1.3-2.7,2-4.5,2s-3.4-0.8-4.5-2C5.4,13.2,4,15.4,4,18v2.9c2.1,1.9,4.9,3.1,8,3.1s5.9-1.2,8-3.1V18
                C20,15.4,18.6,13.2,16.5,12z"/>
              </svg>

              <svg v-if="userIsAnonymous" class="svgWarning" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="24" height="24" viewBox="0 0 24 24"><path d="M13,13H11V7H13M13,17H11V15H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" /></svg>
            </div>

            <div class="profile-menu" v-show="profileOpened" @click.stop>

              <figure>
                <img v-if="userAvatar" :src="userAvatar">

                <svg v-if="!userAvatar" class="svgNoAvatar" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 24 24" xml:space="preserve">
                  <circle cx="12" cy="8" r="5"/>
                  <path d="M16.5,12c-1.1,1.3-2.7,2-4.5,2s-3.4-0.8-4.5-2C5.4,13.2,4,15.4,4,18v2.9c2.1,1.9,4.9,3.1,8,3.1s5.9-1.2,8-3.1V18
                  C20,15.4,18.6,13.2,16.5,12z"/>
                </svg>

                <svg v-if="userIsAnonymous" class="svgWarning" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="24" height="24" viewBox="0 0 24 24"><path d="M13,13H11V7H13M13,17H11V15H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" /></svg>

                <label>
                  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 60 60" xml:space="preserve">
                    <g>
                      <path d="M30,20.5c-6.617,0-12,5.383-12,12s5.383,12,12,12s12-5.383,12-12S36.617,20.5,30,20.5z"/>
                      <path d="M55.201,15.5h-8.524l-4-10H17.323l-4,10H12v-5H6v5H4.799C2.152,15.5,0,17.652,0,20.299v29.368
                      C0,52.332,2.168,54.5,4.833,54.5h50.334c2.665,0,4.833-2.168,4.833-4.833V20.299C60,17.652,57.848,15.5,55.201,15.5z M10,15.5H8v-3
                      h2V15.5z M30,50.5c-9.925,0-18-8.075-18-18s8.075-18,18-18s18,8.075,18,18S39.925,50.5,30,50.5z M52,27.5c-2.206,0-4-1.794-4-4
                      s1.794-4,4-4s4,1.794,4,4S54.206,27.5,52,27.5z"/>
                    </g>
                  </svg>
                  <input type="file" @change="onFileChange">
                </label>

              </figure>

              <p v-if="!userIsAnonymous">{{ userEmail }}</p>

              <p v-if="userIsAnonymous" class="anonymousWarning"><a href="#" @click.prevent="identifyAnonymous">Você ainda não é um usuário registrado. Registre-se aqui para que suas configurações sejam salvas.</a></p>

              <a v-if="userIsAnonymous" class="menu-item" href="#" @click.prevent="identifyAnonymous">Registrar</a>

              <router-link to="meu-perfil" v-if="!userIsAnonymous" class="menu-item">Meu perfil</router-link>

              <a v-if="!userIsAnonymous" class="menu-item" href="#" @click.prevent="logout">Logout </a>



            </div>

          </div>
<!--
          <div id="donate">
            <p>Ajude-nos a manter esta plataforma</p>

            <form action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_blank">
              <input type="hidden" name="cmd" value="_s-xclick" />
              <input type="hidden" name="hosted_button_id" value="JA4SMG9S8TFE4" />

              <button type="submit"><span>Doe R$ 5,00</span><i></i></button>
              <img alt="" border="0" src="https://www.paypal.com/pt_PT/i/scr/pixel.gif" width="1" height="1" />
            </form>

          </div>
-->

        </div>
      </div>
    </header>
    <main>

      <keep-alive exclude="['login']">
        <router-view v-if="authInitialized" />
      </keep-alive>

      <loader/>


    </main>
    <footer class="app-footer theme-bg-3 theme-color-3" v-if="route!='login'">
      <div class="container">
        <div class="links-footer theme-color-3">
          <router-link to="politica-de-privacidade">Política de privacidade</router-link>
          <router-link to="termos-e-condicoes">Termos e condições de uso</router-link>
          <router-link to="contato">Contato</router-link>
          <router-link to="quem-somos">Quem somos</router-link>
        </div>
        <div class="social-links">
          <!-- <iframe src="https://www.facebook.com/plugins/share_button.php?href=https%3A%2F%2Furlinks-beta.firebaseapp.com&layout=button&size=large&width=125&height=28&appId" width="125" height="28" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowTransparency="true" allow="encrypted-media"></iframe> -->
          <a href="https://www.instagram.com/urlinks.com.br" target="_blank" class="instagram">Instagram</a>
          <iframe src="https://www.facebook.com/plugins/like.php?href=https%3A%2F%2Fwww.facebook.com%2Furlinks.com.br&width=140&layout=button&action=like&size=small&show_faces=true&share=true&height=65&appId=731626573957187" width="140" height="65" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowTransparency="true" allow="encrypted-media"></iframe>

        </div>

      </div>

    </footer>
    <router-view v-if="authInitialized" name="popup" :key="$route.fullPath"/>
  </div>
</template>

<style>


.site-header {
  background:#fff;
  padding:15px 0;
  box-shadow: 0 2px 5px rgba(0,0,0,0.2);
  position: fixed;
  top:0;
  left:0;
  right:0;
  z-index: 10;
  height:82px;
}

main {
  padding-top:82px;
  min-height: calc(100vh - 139px);
}

.logo { position:relative; }
.logo h1 {
  background: url(../public/images/logo2020.png) no-repeat center;
 
  background-size: contain;
  width: 180px;
  height: 52px;
  text-indent: -9999px;
}
.logo a {
position: absolute;
top:0; left:0; right:0; bottom:0; z-index:2;
 }

  .search{}
  .search form{ position:relative;}
  .search .field { position:relative;
    background: #fff;
    display: flex;
    border-radius: 8px;
    border: 1px solid #dfe1e5;
    box-shadow: none;
    width: 490px;
    border-radius: 100px;
    z-index: 3;
    height: 40px;
    margin: 0 auto;
    box-shadow:1px 1px 5px rgba(0,0,0,.5);
  }
  .search input{ background:none; border:none; width:100%; font:inherit;  padding:5px 10px;}
  .search button{
    background:none; border:none;
    cursor: pointer;
    border-right: 1px solid #ccc;
    padding: 0 10px 0 15px;
  }
  .search button svg{width: 26px;height: 26px;}
  .search button svg path{ fill:#4285f4 }
  .search .powered {
    background: url(/images/powered-by-google.png) no-repeat center right;
    background-size: contain;
    height: 10px;
    position: absolute;
    z-index: 3;
    width: 80px;
    right: 15px;
    bottom: 5px;

  }


.site-header .anonymousWarning { position: relative; width: 200px; }
.site-header .anonymousWarning a { display:block; color:#c00; font-size:14px; }


.site-header #profile { position: relative; width: 50px; margin-right:70px; display: flex; align-items: center; }
.site-header #profile.isAnonymous {  width: 250px;}
.site-header #profile .avatar { cursor: pointer; width:50px; height:50px; border:2px solid #47cdd1; border-radius: 50px;overflow: hidden; margin:0 auto;}
.site-header #profile .avatar img {width:100%; height:100%; display: block; object-fit: cover;}
.site-header #profile svg.svgNoAvatar { width:100%; height:100%; display: block;}
.site-header #profile .avatar svg.svgNoAvatar path { fill:#47cdd1; }
.site-header #profile .avatar svg.svgNoAvatar circle { fill:#47cdd1; }

.site-header #profile .svgWarning { position: absolute; top:0; right:0; width:20px; height:20px; }
.site-header #profile .svgWarning path { fill:#c00;}

.site-header .profile-menu .anonymousWarning { width:100%; }
.site-header .profile-menu .anonymousWarning a { color: #009393}

.site-header .profile-menu { position: absolute; top:100%; top:calc(100% + 10px); right:0; padding:20px; background-color: #fff; box-shadow: 1px 1px 5px rgba(0,0,0,.5); border-radius: 5px;text-align:center; min-width:300px; }
.site-header .profile-menu figure{ position:relative; width:80px; height:80px; border:2px solid #47cdd1; border-radius: 40px; margin: 0 auto 20px; }
.site-header .profile-menu figure img {width:100%; height:100%; display: block; object-fit: cover; border-radius: 80px;}
.site-header .profile-menu figure > svg path { fill:#47cdd1; }
.site-header .profile-menu figure > svg circle { fill:#47cdd1; }
.site-header #profile .profile-menu figure svg.svgWarning { width:30px; height:30px; }
.site-header .profile-menu label{ cursor: pointer; position: absolute; bottom:0; right:0; width:30px; height:30px; background-color:#fff; padding:5px; border-radius: 100%; }
.site-header .profile-menu label svg path{ fill:#999; }
.site-header .profile-menu label svg circle { fill:#999; }
.site-header .profile-menu label input { display: none;}
.site-header .profile-menu p { margin-bottom:10px;}
.site-header .profile-menu .menu-item { border:1px solid #dadce0; padding: 10px 24px; display: block; margin:10px 0; color:#333; }

#donate{ width:150px; }
#donate p{ margin-bottom:5px; color:#999; font-size:14px; line-height:1.2; text-align:center; }
#donate button { cursor:pointer; display:flex;justify-content: space-between;align-items: center;background-color:#fff;width:100%; border-radius:50px;padding: 2px 10px; border:none; font:inherit; box-shadow:1px 1px 5px rgba(0,0,0,.5);}
#donate button span{color:#1cc4cf;font-weight: bold;font-size: 11px;}
#donate button i { display:inline-block; width:50px; height:20px; background:url(../public/images/paypal.png) no-repeat center; background-size: contain;  }
#donate img { width:1px; height:1px; position: absolute;}



.app-footer{
  padding:30px 0;
  color: #fff;
  background: #1cc4cf;
}

.links-footer { display: flex;justify-content: center; margin-bottom:20px; }
.links-footer a {color:inherit; padding:5px 10px;}
.links-footer a:not(:last-child) { border-right: 1px solid #000; border-color:inherit; }
.social-links { text-align: center; display: flex; align-items: flex-start; justify-content: center; }
.social-links .instagram { text-indent: -9999px; display: inline-block; width:20px; height:20px; background:url(../public/images/instagram.png) no-repeat center; background-size:contain; margin-right: 10px; }
.social-links iframe {/* height: 65px;*/ height: 25px;  }

body.is-mobile { overflow-x:hidden; }

body.is-mobile .search { display: none; }
body.is-mobile #donate { display: none }
body.is-mobile .app-footer { display: none }
body.is-mobile #anonymousWarning { display: none }
body.is-mobile #profile { display: none }

body.is-mobile main {padding-top:48px;}

body.is-mobile .site-header { height:auto; padding:10px 0;}
body.is-mobile .site-header .flex { justify-content: center;}
body.is-mobile .logo {top:0; }
body.is-mobile .logo h1 {height: 22px; margin: 3px 0; }



</style>

<script>

  import Loader from './components/Loader.vue';

  export default {
    name: 'app',
    data(){
      return {
        profileOpened:false,
      }
    },
    components: {
      Loader
    },
    computed:{
      authInitialized(){
        return this.$store.state.authInitialized
      },
      isAuthenticated(){
        return this.$store.state.isAuthenticated
      },
      userIsAnonymous(){
        return this.$store.state.user.isAnonymous==true
      },
      userid(){
        return this.$store.getters.userId
      },
      userEmail(){
        return this.$store.getters.user.email
      },
      userAvatar(){
        return this.$store.getters.preferenceAvatar;
      },
      route(){
        return this.$route.name
      },
    },
    methods: {
      logout() {
        this.$store.dispatch('userSignOut');
      },
      identifyAnonymous(){
        this.$store.dispatch('anonymousRedirectLogin');
      },

      onFileChange(e){
        console.log('change');
        var files = e.target.files || e.dataTransfer.files;
        if (!files.length) return;
        var file = files[0];
        console.log(file);
        var reader = new FileReader();
        var img = new Image();
        reader.onload = (re) => {

          console.log('reader load');
          img.onload = (ie) => {
            console.log('img load');

            var MAX_WIDTH = 800;
            var MAX_HEIGHT = 800;
            var width = img.width;
            var height = img.height;

            if (width > height) {
              if (width > MAX_WIDTH) {
                height *= MAX_WIDTH / width;
                width = MAX_WIDTH;
              }
            } else {
              if (height > MAX_HEIGHT) {
                width *= MAX_HEIGHT / height;
                height = MAX_HEIGHT;
              }
            }

            var canvas = document.createElement('canvas');
            var ctx = canvas.getContext("2d");

            canvas.width = width;
            canvas.height = height;
            ctx.drawImage(img, 0, 0, width, height);
            var dataurl = canvas.toDataURL("image/jpeg");

            this.$store.dispatch('setAvatar',{image:dataurl});

          }
          img.src = re.target.result;
        }
        reader.readAsDataURL(file);
      },

    },
    mounted(){
      this.profileOpened = false;
      document.querySelector('body').addEventListener('click',(e)=>{
        this.profileOpened = false;
      })
    },
    created(){

      if(isMobile()){
        document.querySelector('body').className+= ' is-mobile';
      }
    }
  }
</script>

